import React from 'react';
import styled from 'styled-components';
import { Modal } from '@material-ui/core';
import { RoundedButton } from 'components/input/RoundedButton';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ModalTitleBar from '../ModalTitleBar';
import ConcurrentSessionModalContainer from './ConcurrentSessionModalContainer';

const ForceLoginButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`;

const ModalButton = styled(RoundedButton)<{ backgroundColor: string }>`
  padding: 4px 16px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  
  &:not(:last-child) { 
    margin-right: 16px;
  }
`;

const ForceLoginModal = ({
  open,
  onConfirm,
  onCancel,
}: {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) => {
  const { t } = useTranslation();
  const { themeColor } = useSelector((s) => s.eventConfigs);

  return (
    <Modal open={open} style={{ zIndex: 500000 }}>
      <ConcurrentSessionModalContainer>
        <ModalTitleBar>{t('concurrent_session.force_kick.title', 'Concurrent Login Detected')}</ModalTitleBar>
        {t('concurrent_session.force_kick.message', 'You have logged in from another device. Are you sure you want to log in here and log out on the other device?')}
        <ForceLoginButtonsContainer>
          <ModalButton onClick={onCancel} backgroundColor={themeColor}>{t('concurrent_session.cancel', 'Cancel')}</ModalButton>
          <ModalButton onClick={onConfirm} backgroundColor={themeColor}>{t('concurrent_session.login_here', 'Log In Here')}</ModalButton>
        </ForceLoginButtonsContainer>
      </ConcurrentSessionModalContainer>
    </Modal>
  );
};

export default ForceLoginModal;
